import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import { widgetPaths } from '~/views/widgets/widget-utils';

import * as S from './EmptyState.styles';

interface EmptyStateProps {
  title?: string;
}

export const EmptyState = ({ title, ...rest }: EmptyStateProps) => {
  const { t } = useTranslation(['widget', 'watchlistManager']);
  const [, setSearchParams] = useSearchParams();

  return (
    <S.Wrapper {...rest}>
      <S.WidgetTitle>
        {title ?? t('widget:watchlist.myAssetsTitle')}
      </S.WidgetTitle>

      <S.StyledNoDataFound
        data-testid="empty-watchlist"
        bannerPath="/terminal/static/images/empty-state/empty-portfolio.svg"
        title={t('widget:watchlist.emptyWatchlistTitle')}
        description={t('widget:watchlist.emptyWatchlistDescription')}
        buttonLabel={t('widget:watchlist.emptyWatchlistBtn')}
        buttonAction={() =>
          setSearchParams({
            widget: widgetPaths.watchlistManagerModal,
          })
        }
      />
    </S.Wrapper>
  );
};
